<template>
    <div>
        <div class="d-flex align-center">
            <div v-if="!referee" class="title flex-grow-1">{{$translate('Coming matches')}}</div>
            <div v-else class="title flex-grow-1"></div>
            <template v-if="matches.length" >
                <v-progress-circular v-if="loading" size="20" indeterminate color="primary" width="2"></v-progress-circular>
                <span v-else-if="!numMatches" style="opacity: 0.5">{{$translate('Showing all')}}</span>
                <a href @click.prevent="getAllComingMatches" v-else>{{$translate('Show all')}}</a>
            </template>
        </div>

        <div v-if="loading && !matches.length" class="d-flex align-center justify-center">
            <v-progress-circular size="20" indeterminate color="primary" width="2"></v-progress-circular>
        </div>
        <template v-else-if="!matches.length">
            <v-card>
                <v-card-text>
                    {{$translate('No matches scheduled')}}
                </v-card-text>
            </v-card>
        </template>
        <template v-else>
            <div v-if="!referee">
                <teamsport-coming-match v-for="match in matches" :key="match.id" :match="match" :teamId="teamId" class="mb-4"/>
            </div>
            <div v-else>
                <teamsport-referee-coming-match v-for="match in matches" :key="match.id" :match="match" class="mb-4"/>
            </div>
            <v-btn v-if="numMatches != null"  @click="getMoreMatches" block outlined color="primary" :loading="loading">{{$translate('Load more matches')}}</v-btn>
        </template>
    </div>
</template>

<script>
import TeamsportComingMatch from './TeamsportComingMatch.vue'
import TeamsportRefereeComingMatch from './TeamsportRefereeComingMatch.vue';
export default {
    name: 'zoezi-teamsport-coming-matches',

    zoezi: {
        title: 'Coming matches',
        icon: 'mdi-calendar-clock',
        addon: 'TeamSports'
    },

    props: {
        teamId: {
            title: 'Registration ID',
            type: Number
        },
        referee: {
            type: Boolean,
            default: false
        }
    },

    components: {
        TeamsportComingMatch,
        TeamsportRefereeComingMatch
    },

    data: () => ({
        matches: [],
        numMatches: 4,
        loading: false,
        unsubscribe: []
    }),

    watch: {
        teamId: {
            immediate: true,
            handler() {
                this.getComingMatches();
            }
        },
    },

    methods: {
        getComingMatches() {
            this.loading = true;
            let url = '';
            let params = {};
            if (this.teamId){
                url = '/api/memberapi/teamsport/match/next';
                params = {team_id: this.teamId, limit: this.numMatches};
            } else if (this.referee) {
                url = '/api/memberapi/teamsport/referee/coming/matches';
                params = {limit: this.numMatches};
            }
            this.$api.get(url, params).then(result => {
                if (!this.referee) {
                    this.matches = result.matches.slice(1);
                } else {
                    this.matches = result.matches;
                }

                this.matches.forEach(m => {
                    this.$booking.transformWorkout(m.activity);
                })
                this.loading = false;
                if (result.count <= this.numMatches) {
                    this.numMatches = null;
                }
            });
        },
        getAllComingMatches() {
            this.numMatches = null;
            this.getComingMatches();
        },
        getMoreMatches() {
            this.numMatches += 4;
            this.getComingMatches();
        }
    },
    mounted() {
        if (this.referee) {
            this.getComingMatches();
        }
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsportmatch', callback: (_, event) => {
            if (event.data.find(x => x.teams && x.teams.find(team => team.id == this.teamId))) {
                this.getComingMatches();
            }
        }}))
    },
    destroyed() {
        this.unsubscribe.forEach(x => x());
    }
}
</script>
